// useIsMobile — 모바일 뷰 판정 훅(반응형 분기용).
// 자동: 뷰포트 폭(좁은 화면) OR 터치 기기(pointer:coarse + hover:none) — 폭만으론 '진짜 폰'과
//       '좁은 데스크톱 창'을 못 가리므로 터치 시그널을 OR로 보강(실제 폰은 가로모드·넓어도 모바일 UI).
//       ⚠️UA 스니핑은 비사용 — iPad가 데스크톱으로 보고/스푸핑/창크기 미반응 등 신뢰성 낮음(레이아웃엔 폭+pointer가 표준).
// 수동: 사용자가 '웹/모바일 화면 전환' 버튼으로 override 시 그 값이 자동 판정보다 우선(localStorage 유지).
// 데스크톱(false)일 땐 기존 레이아웃 100% 유지 — 분기 추가만, 기존 경로 불변.
import { useState, useEffect } from 'react';

const VIEW_KEY = 'gwViewMode';     // '' = 자동, 'mobile' = 강제 모바일, 'desktop' = 강제 데스크톱
const VIEW_EVENT = 'gw-viewmode';  // 같은 탭 즉시 반영용 커스텀 이벤트

export function getViewMode() {
  try { return localStorage.getItem(VIEW_KEY) || ''; } catch (e) { return ''; }
}

// mode: 'mobile' | 'desktop' | '' (빈값=자동 복귀). 전 페이지(useIsMobile 구독자) 즉시 갱신.
export function setViewMode(mode) {
  try {
    if (mode === 'mobile' || mode === 'desktop') localStorage.setItem(VIEW_KEY, mode);
    else localStorage.removeItem(VIEW_KEY);
  } catch (e) { /* */ }
  try { window.dispatchEvent(new Event(VIEW_EVENT)); } catch (e) { /* */ }
}

const TOUCH_Q = '(pointer: coarse) and (hover: none)';

export default function useIsMobile(query = '(max-width: 768px)') {
  const compute = () => {
    const override = getViewMode();
    if (override === 'mobile') return true;
    if (override === 'desktop') return false;
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches || window.matchMedia(TOUCH_Q).matches;
  };
  const [mobile, setMobile] = useState(compute);
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const on = () => setMobile(compute());
    on();   // 마운트 시 동기화(override·초기값 반영)
    const mqW = window.matchMedia(query);
    const mqT = window.matchMedia(TOUCH_Q);
    if (mqW.addEventListener) { mqW.addEventListener('change', on); mqT.addEventListener('change', on); }
    else { mqW.addListener(on); mqT.addListener(on); }   // Safari < 14 폴백
    window.addEventListener(VIEW_EVENT, on);   // 같은 탭에서 수동 전환
    window.addEventListener('storage', on);    // 다른 탭과 동기화
    return () => {
      if (mqW.removeEventListener) { mqW.removeEventListener('change', on); mqT.removeEventListener('change', on); }
      else { mqW.removeListener(on); mqT.removeListener(on); }
      window.removeEventListener(VIEW_EVENT, on);
      window.removeEventListener('storage', on);
    };
  }, [query]);   // eslint: compute는 query만 의존(override/matchMedia는 이벤트로 재평가)
  return mobile;
}
